import * as PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';
import packageJSON from '../../../package.json';
import CreditCurrencyLogo from '../../assets/target/images/CreditCurrencyLogo.svg';
import { t } from '../../lang';
import HelperService from '../../services/HelperService';
import Button from '../Button';
import Icon, { Icons } from '../Icon/Icon';
import Input from '../Input';

import './CreditsBalanceHeader.scss';

const CREDIT_CURRENCY = packageJSON?.creditCurrency ?? 'Credits';
const SETTING_ICON_SIZE = 24;

const CreditsBalanceHeader = ({ topUpAction }) => {
	const theme = useSelector(state => state?.app?.theme);
	const billingBalance = useSelector(state => state.app.billingBalance);

	return (
		<div className='CreditsBalanceHeader'>
			<Icon
				className={'CreditsBalanceHeader-setting-icon theme-' + theme}
				type={Icons.SETTING}
				width={SETTING_ICON_SIZE}
				height={SETTING_ICON_SIZE}
			/>
			<div className='CreditsBalanceHeader__right-side'>
				<img src={CreditCurrencyLogo} alt='billing-logo' className='CreditsBalanceHeader__billing-logo' />
				<div className='CreditsBalanceHeader__balance'>
					{HelperService.FormatFiatWithoutCurrency(billingBalance)} {CREDIT_CURRENCY}
				</div>
				<Button className='CreditsBalanceHeader__topUp-button' onClick={topUpAction}>
					{t('Top up')}
				</Button>
			</div>
		</div>
	);
};

Input.propTypes = {
	topUpAction: PropTypes.func,
};

export default CreditsBalanceHeader;
